var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3376 30.9242C22.3759 27.4829 11.08 17.1334 14.5 1.5C6.02838 3.56974 -2.00592 16.6905 4.33244 29.2857C10.4692 41.4803 26.8882 40.3193 36.3376 30.9242Z",
    fill: "#323232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1.5L15.7211 1.76713C15.8133 1.3458 15.6817 0.906716 15.3731 0.605464C15.0645 0.304211 14.6223 0.183354 14.2033 0.285715L14.5 1.5ZM36.3376 30.9242L37.2189 31.8106C37.5392 31.4921 37.6628 31.0256 37.5421 30.5903C37.4215 30.1549 37.0753 29.8186 36.6367 29.7105L36.3376 30.9242ZM4.33244 29.2857L5.44902 28.7238L5.44902 28.7238L4.33244 29.2857ZM13.2789 1.23287C11.4854 9.43122 13.5548 16.3198 17.9403 21.5842C22.2941 26.8106 28.8696 30.3709 36.0384 32.1379L36.6367 29.7105C29.8439 28.0362 23.7906 24.7011 19.8611 19.9841C15.9632 15.3051 14.0946 9.20219 15.7211 1.76713L13.2789 1.23287ZM35.4562 30.0378C30.9561 34.512 24.8062 37.0073 19.1051 36.9511C13.4446 36.8953 8.27528 34.3399 5.44902 28.7238L3.21586 29.8476C6.5264 36.4261 12.6349 39.3874 19.0804 39.451C25.4854 39.5142 32.2696 36.7315 37.2189 31.8106L35.4562 30.0378ZM5.44902 28.7238C2.46608 22.7963 2.86488 16.7626 5.00452 11.954C7.1652 7.09811 11.0283 3.63495 14.7967 2.71429L14.2033 0.285715C9.50007 1.43479 5.11022 5.56689 2.72043 10.9376C0.309609 16.3557 -0.139555 23.18 3.21586 29.8476L5.44902 28.7238Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkBtn);
export default __webpack_public_path__ + "static/media/DarkBtn.efa19b9dfbf18e1016c4822ef6fce28d.svg";
export { ForwardRef as ReactComponent };